<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencilAlt, faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';

import Pagination from '@/components/Pagination';

library.add( faPencilAlt, faTrash, faSpinner );

export default {
  name: 'ModuleInvitationsList',
  components: {
    Pagination,
  },
  computed: {
    ...mapState('invitation/collection', [
      'items',
      'pagination',
      'isLoading',
    ]),
    page: {
      get() {
        return this.pagination.page;
      },
      set(page) {
        this.setPage(page);
        const query = Object.assign({}, this.query);
        this.fetch(query);
      },
    },
    query() {
      const { query } = this.$route;
      return query.q || null;
    },
  },
  watch: {
    query: function(newQuery, oldQuery) {
      if (newQuery === oldQuery) {
        return;
      }
      this.fetch(newQuery);
    },
  },
  methods: {
    ...mapActions('invitation/collection', [
      'fetch',
    ]),
    ...mapMutations('invitation/collection', [
      'setPage',
    ]),
    ...mapActions('invitation/item', [
      'remove',
    ]),
    confirmDelete(item) {
      this.$dialog.confirm(`Are you sure you want to delete <strong>${item.code}</strong>?`, { loader: true, html: true })
        .then(dialog => this.remove(item.id).then(() => {
          this.fetch().then(() => dialog.close());
        }))
        .catch(() => {})
      ;
    },
    getUserFullName(item) {
      const { first_name = null, last_name = null } = item;
      return first_name && last_name ? `${first_name} ${last_name}` : `${first_name || ''}${last_name || ''}`;
    },
  },
  created() {
    this.fetch(this.query);
  },
};
</script>
<template>
  <div class="box">
    <div class="d-flex justify-content-between mb-3">
      <h2>Invitations</h2>
      <div class="actions d-flex">
        <router-link :to="{ name: 'invitations-create-bulk' }" class="btn btn-info mr-3 flex-none">
          Generate Bulk Code
        </router-link>
        <router-link :to="{ name: 'invitations-create' }" class="btn btn-primary flex-none">
          New Code
        </router-link>
      </div>
    </div>
    <table>
      <caption>
        <Pagination :pagination="pagination" :type="'codes'" v-model="page"></Pagination>
      </caption>
      <thead>
        <tr>
          <th>Code</th>
          <th>User</th>
          <th>Activated At</th>
          <th>Expires At</th>
          <th>Created At</th>
          <th class="w-25">Actions</th>
        </tr>
      </thead>
      <tbody>
      <tr v-if="isLoading">
        <td colspan="8" class="text-center">
          <font-awesome-icon icon="spinner" size="3x" spin class="mt-3 mb-3" />
        </td>
      </tr>
      <tr v-else-if="!items.length">
        <td colspan="8" class="text-center">
          There are no invitation codes
        </td>
      </tr>
      <tr v-else v-for="(item, index) in items" :key="item.id" :class="{ primary: index % 2 === 0 }">
        <td>{{ item.code }}</td>
        <td>
          <router-link :to="{ name: 'users-edit', params: { 'id': item.user.id } }" v-if="item.user.id">
            {{ getUserFullName(item.user) }}
          </router-link>
          <span v-else>
            {{ getUserFullName(item.user) }}
          </span>
        </td>
        <td>{{ item.activatedAt }}</td>
        <td>{{ item.expiresAt }}</td>
        <td>{{ item.createdAt }}</td>
        <td class="w-25">
          <router-link :to="{ name: 'invitations-edit', params: { id: item.id } }" class="mr-3">
            <font-awesome-icon icon="pencil-alt" />
          </router-link>
          <a @click="confirmDelete(item)" class="pointer text-danger">
            <font-awesome-icon icon="trash" />
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
